import { render, staticRenderFns } from "./vCustomers.vue?vue&type=template&id=c178e8d2&scoped=true"
import script from "./vCustomers.vue?vue&type=script&lang=js"
export * from "./vCustomers.vue?vue&type=script&lang=js"
import style0 from "./vCustomers.vue?vue&type=style&index=0&id=c178e8d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c178e8d2",
  null
  
)

export default component.exports